var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"side-content"}},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t("message")))]),_c('div',{staticClass:"app-version"},[_vm._v("v1.25.10")])])}
var staticRenderFns = []

export { render, staticRenderFns }